import { motion } from "framer-motion";

interface AnimatedWavesProps {
  fill?: string;
  className?: string;
}

const AnimatedWaves = ({ fill = "hsl(var(--background))", className = "" }: AnimatedWavesProps) => {
  return (
    <div className={`absolute -bottom-px left-0 right-0 pointer-events-none overflow-hidden ${className}`} style={{ height: "120px" }}>
      {/* Wave 1 - front — seamless loop: SVG contains 2 identical periods, we shift by exactly 1 period */}
      <motion.div
        className="absolute bottom-0 w-[200%] h-full"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
      >
        <svg viewBox="0 0 2880 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" preserveAspectRatio="none">
          <path
            d="M0 80C120 60 240 100 360 80C480 60 600 100 720 80C840 60 960 100 1080 80C1200 60 1320 100 1440 80C1560 60 1680 100 1800 80C1920 60 2040 100 2160 80C2280 60 2400 100 2520 80C2640 60 2760 100 2880 80V120H0V80Z"
            fill={fill}
            fillOpacity="0.9"
          />
        </svg>
      </motion.div>

      {/* Wave 2 - middle */}
      <motion.div
        className="absolute bottom-0 w-[200%] h-full"
        animate={{ x: ["-50%", "0%"] }}
        transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
      >
        <svg viewBox="0 0 2880 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" preserveAspectRatio="none">
          <path
            d="M0 90C180 70 360 110 540 90C720 70 900 110 1080 90C1260 70 1440 110 1620 90C1800 70 1980 110 2160 90C2340 70 2520 110 2700 90C2880 70 2880 90 2880 90V120H0V90Z"
            fill={fill}
            fillOpacity="0.5"
          />
        </svg>
      </motion.div>

      {/* Wave 3 - back */}
      <motion.div
        className="absolute bottom-0 w-[200%] h-full"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
      >
        <svg viewBox="0 0 2880 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" preserveAspectRatio="none">
          <path
            d="M0 100C160 85 320 115 480 100C640 85 800 115 960 100C1120 85 1280 115 1440 100C1600 85 1760 115 1920 100C2080 85 2240 115 2400 100C2560 85 2720 115 2880 100V120H0V100Z"
            fill={fill}
            fillOpacity="0.3"
          />
        </svg>
      </motion.div>
    </div>
  );
};

export default AnimatedWaves;
